// All AI calls go through Firebase Cloud Functions — the API key never touches the frontend.
import { getAuth } from 'firebase/auth';

const FUNCTIONS = {
  suggestSummary:             'https://suggestsummary-yzeylo33ka-ue.a.run.app',
  suggestBullets:             'https://suggestbullets-yzeylo33ka-ue.a.run.app',
  parseResume:                'https://parseresume-yzeylo33ka-ue.a.run.app',
  suggestSkills:              'https://suggestskills-yzeylo33ka-ue.a.run.app',
  generateCoverLetterSection: 'https://generatecoverlettersection-yzeylo33ka-ue.a.run.app',
  generateCoverLetterAll:     'https://generatecoverletterall-yzeylo33ka-ue.a.run.app',
  analyzeJobMatch:            'https://analyzejobmatch-yzeylo33ka-ue.a.run.app',
  suggestPageFit:             'https://suggestpagefit-yzeylo33ka-ue.a.run.app',
};

async function post(endpoint, body) {
  const auth = getAuth();
  const token = auth.currentUser ? await auth.currentUser.getIdToken() : null;
  const headers = { 'Content-Type': 'application/json' };
  if (token) headers['Authorization'] = `Bearer ${token}`;

  const res = await fetch(FUNCTIONS[endpoint], {
    method: 'POST',
    headers,
    body: JSON.stringify(body),
  });
  if (!res.ok) {
    const { error } = await res.json().catch(() => ({}));
    throw new Error(error || `Server error ${res.status}`);
  }
  return res.json();
}

export async function suggestSummary({ name, title, skills, experience, existingSummary }) {
  const { summary } = await post('suggestSummary', { name, title, skills, experience, existingSummary });
  return summary;
}

export async function suggestBullets({ role, company, existingBullets }) {
  const { bullets } = await post('suggestBullets', { role, company, existingBullets });
  return bullets;
}

export async function parseResume({ text }) {
  const { resume } = await post('parseResume', { text });
  return resume;
}

export async function suggestSkills({ experience, personal, existingSkills }) {
  const { skills } = await post('suggestSkills', { experience, personal, existingSkills });
  return skills;
}

export async function generateCoverLetterSection({ section, targetCompany, targetRole, existingText, resumeInfo }) {
  const { text } = await post('generateCoverLetterSection', { section, targetCompany, targetRole, existingText, resumeInfo });
  return text;
}

export async function generateCoverLetterAll({ targetCompany, targetRole, resumeInfo }) {
  const { sections } = await post('generateCoverLetterAll', { targetCompany, targetRole, resumeInfo });
  return sections;
}

export async function analyzeJobMatch({ url, jobText, resume }) {
  const { analysis } = await post('analyzeJobMatch', { url, jobText, resume });
  return analysis;
}

export async function suggestPageFit({ resume, currentPages, targetPages }) {
  const { result } = await post('suggestPageFit', { resume, currentPages, targetPages });
  return result;
}
